import { Grid, Skeleton, Box } from "@mui/material";

export default function SkeletonCommonExternalDynamicArticles({ loading = false, count = 7 }) {
  if (!loading) return <></>;

  const ColumnSkeleton = () => (
    <Grid item xs={12} sm={6} md={3}>
      <Box>
        <Skeleton variant="text" width="80%" height={24} sx={{ mb: 2 }} />
        {[...Array(count)].map((_, index) => (
          <Box key={index} sx={{ mb: 1.5 }}>
            <Skeleton variant="text" width={`${Math.random() * 30 + 60}%`} height={48} />
          </Box>
        ))}
      </Box>
    </Grid>
  );

  return (
    <Grid item container direction="row" spacing={4} justifyContent="space-around" pb={'48px'}>
      <ColumnSkeleton />
      <ColumnSkeleton />
      <ColumnSkeleton />
      <ColumnSkeleton />
    </Grid>
  );
}